<template>
  <b-overlay :show="loading" opacity="0.8">
    <div v-if="can('admin:CanViewDashboard')">
      <b-row class="match-height">
        <b-col
          xl="12"
          md="12"
        >
         
          <hospital-statistics :user-statistics="getValueFromSource(dashboardStats, 'hospital_stats', [])" />

          <div class="card shadow pb-2">
            <h4 class="text-dark" style="font-weight: 500; font-size: 15px; line-height: 22.5px; color:#4B4B4B; padding-left: 1em; padding-top: 1em; ">
                Statistics
            </h4>
            <hr style="margin-top:0" /> 

            <!-- Patients -->
            <div>
              <div class="d-flex justify-content-between" style="margin-bottom: 2px;">
                <div style="font-weight: 500; font-size: 15px; line-height: 22.5px; padding-left: 1em; ">Patients</div>
              </div>
            </div>

            <!-- patients-data -->
          <general-statistics :patient-statistics="getValueFromSource(dashboardStats, 'patients_stats', [])" />


           <!-- Lab requests -->
           <div>
              <div style="margin-bottom: 2px; margin-top: 10px;">
                <div style="font-weight: 500; font-size: 15px; line-height: 22.5px; padding-left: 1em; ">Lab requests</div>
              </div>
            </div>

            <!-- LabRequests-data -->
          <general-statistics :patient-statistics="getValueFromSource(dashboardStats, 'lab_stats', [])" />

           <!-- Prescription requests -->
           <div>
              <div style="margin-bottom: 2px; margin-top: 10px;">
                <div style="font-weight: 500; font-size: 15px; line-height: 22.5px; padding-left: 1em; ">Prescription requests</div>
              </div>
            </div>

            <!-- Prescription requests-data -->
          <general-statistics :patient-statistics="getValueFromSource(dashboardStats, 'prescription_stats', [])" />

          </div>

      
          <other-statistics :other-statistics="getValueFromSource(dashboardStats, 'other_stats', [])" />
        </b-col>
      </b-row>

      <b-row>
        <b-col
          md="8"
        >
          <div class="mb-3">
            <series-chart
              :series="getValueFromSource(graphStats, 'graph_series', [])"
              :chart-options="chartOptions"
              :graph-year.sync="graphYear"
              :loading="loading"
              @graphRegion="updateGraphByRegion"
            />
          </div>

      
        </b-col>

        <b-col md="4">
          <div class="card shadow pb-2">
            <h4 class="text-dark" style="font-weight: 500; font-size: 16px; line-height: 24px; color:#4B4B4B; padding-left: 1em; padding-top: 1em; ">Upcoming schedules</h4>
            <hr style="margin-top:0" /> 

            <div style="margin-left: 2em">
              <div v-for="(schedule , index) in getValueFromSource(dashboardStats, 'upcoming_schedules', [])" :key="index" class="d-flex justify-content-between">
                  <div class="circle"></div>
                  <div v-if="index === 0" class="first-schedule">
                    <b-row>
                      <b-col md="4">
                        <div class="highlight">{{ formatDateTime(schedule.appointment_date) }}</div>
                      </b-col>
                      <b-col md="8">
                        <div class="highlight">
                          Appointment with {{ getValueFromSource(schedule, 'patient.full_name', "") }}
                        </div>
                      </b-col>

                      <b-col md="4" class="mt-1">
                        <div class="schedule-info">Time</div>
                      </b-col>
                      <b-col md="8" class="mt-1">
                        <div class="schedule-info">{{ formatDateTime(schedule.appointment_date) }}</div>
                      </b-col>

                      <b-col md="4" class="mt-1">
                        <div class="schedule-info">Type</div>
                      </b-col>
                      <b-col md="8" class="mt-1">
                      <div class="schedule-info pb-1">Video Consultation</div>
                      </b-col>
                    </b-row>
                    <hr style="margin-top:0" /> 

                    <b-link 
                      v-if="currentUserProfession === 'nurse' || currentUser.id === getValueFromSource(schedule, 'medical_professional_id')"
                      class="begin-session"
                      @click="onBegin(getValueFromSource(schedule, 'id'))"
                    >
                      Begin Session 
                    </b-link>
                  </div>

                  <div v-else class="schedules">
                    <span class="mr-1">{{ formatDateTime(schedule.appointment_date) }}</span> Appointment with {{ getValueFromSource(schedule, 'patient.full_name', "") }}
                  </div>
              </div>
            </div>
            <div v-if="getValueFromSource(dashboardStats, 'upcoming_schedules', []).length === 0" style="margin-left: 2em">
              No upcoming schedules for today
            </div>
          </div>
        </b-col>
      </b-row>

      <b-row class="match-height">
        <b-col xl="12" md="12">
          <div>
            <PartnersChart />
          </div>
        </b-col>
      </b-row>
    </div>
  </b-overlay>
</template>

<script>
import { get } from "lodash"
import { startOfMonth } from 'date-fns'
import { formatDate } from "@/@core/utils/utils"
import { kFormatter } from '@/@core/utils/filter'
import { BCardText, BCol, BImg, BOverlay, BRow, BLink } from 'bootstrap-vue'

import vSelect from 'vue-select'
import OtherStatistics from '@/pages/main/home/OtherStatistics.vue'
import GeneralStatistics from '@/pages/main/home/GeneralStatistics.vue'
import SeriesChart from "@/pages/main/home/SeriesChart.vue"
import PartnersChart from "@/pages/main/home/PartnersChart.vue"
import HospitalStatistics from '@/pages/main/home/HospitalStatistics.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

const watchHandler = {
  handler(){
    this.fetchDashboardStatsData()
  }, 
  immediate: false
}

export default {
  components: {
    BImg,
    BRow,
    BCol,
    BLink,
    BOverlay,
    BCardText,
    SeriesChart,
    PartnersChart,
    HospitalStatistics,
    OtherStatistics,
    GeneralStatistics,
    vSelect
  },
  data(){
    const monthBeginning = new Date(startOfMonth(new Date()));
    const chartOptions = {
      chart: {
        height: 400,
        type: 'area',
        toolbar: {
          show: true,
          tools: {
            download: true,
            selection: false,
            zoom: false,
            zoomin: false,
            zoomout: false,
            pan: false,
            reset: false
          }
        }
      },
      dataLabels: {
        enabled: false,
        formatter: (value) => kFormatter(value),
      },
      series: [
        {
          name: 'Subscribers',
          data: [
            0,
            0,
            0,
            0,
            0,
            5,
            0,
            0,
            10,
            0,
            0,
            0
          ]
        },
      ],
      colors: ['rgba(7, 125, 188, 1)', 'rgba(101, 163, 13, 1)', 'rgba(7, 125, 188, 0.7)'],
      grid: {
        xaxis: {
          lines: {
            show: false,
          },
        },
        yaxis: {
          lines: {
            show: true,
          },
        },
      },
      fill: {
        type: "gradient",
        gradient: {
          shadeIntensity: 1,
          opacityFrom: 0.7,
          opacityTo: 0.9,
          stops: [0, 90, 100],
        },
      },
      xaxis: {
        lines: {
          show: false
        },
        type: 'string',
        categories: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec"
        ]
      },
      yaxis: {
        lines: {
          show: false
        },
        labels: {
          formatter: (value) => value
        }
      },
      tooltip: {
        x: {
          format: 'MM/yy'
        },
        y: {
          formatter: (value) => value
        }
      },
      legend: {
        position: "top",
        horizontalAlign: 'left'
      }
    }

    return {
      loading: false,
      chartOptions,

      insuranceFilter: "",
      graphStats: null,
      dashboardStats: null,
      graphYear: new Date().getFullYear(),
      to: formatDate(new Date(), 'yyyy-MM-dd'),
      from: formatDate(monthBeginning, 'yyyy-MM-dd'),
    }
  },
  watch: {
    from: watchHandler,
    to: watchHandler,
    graphYear: {
      handler(){
        this.fetchDashboardGraphData()
      }, 
      immediate: true
    },
  },
  created() {
    this.fetchDashboardStatsData();
  },

  methods: {
    async fetchDashboardStatsData(){
      try {
        if (!this.can(['admin:CanViewDashboard'])) { return }
        this.loading = true; 

        const request = await this.useJwt().mainService.dashboard.fetchStats({
          from: this.from,
          to: this.to
        });

        
        const { data } = request.data;
        this.dashboardStats = data;
      } catch (error) {
        const error_message = get(error, "response.data.message") || error.message
        console.log("error_message", error_message)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error_message
          },
        });
      } finally {
        this.loading = false;
      }
    },
    async fetchDashboardGraphData(region = ""){
      try {
        if (!this.can(['admin:CanViewDashboard'])) { return }
        this.loading = true; 

        const request = await this.useJwt().mainService.dashboard.fetchGraph({
          year: this.graphYear,
          region
        });
        
        const { data } = request.data;
        
        this.graphStats = data;
      } catch (error) {
        const error_message = get(error, "response.data.message") || error.message
        console.log("error_message", error_message)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error_message
          },
        });
      } finally {
        this.loading = false;
      }
    },
    async onBegin(appointment_id){
      try {
        this.loading = true;
        this.errorMessage = "";

        if (!this.can('appointments:CanUpdate')) {
          return
        }

        if (!this.can('consultations:CanAddNew')) {
          return
        }

        const response = await this.useJwt().mainService.appointments.startConsultation(appointment_id);
        const id = get(response, 'data.data.id');
        const consultation_data = get(response, 'data.data');

        if (id && consultation_data.consultation_type === 'medical'){
          this.$router.push({
            params: { id },
            name: 'admin-medical-consultation-edit',
          })
        }

        if (id && consultation_data.consultation_type === 'dietary'){
          this.$router.push({
            params: { id },
            name: 'admin-dietary-consultation-edit',
          })
        }
        
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Success!',
            icon: 'CheckCircleIcon',
            variant: 'success',
            text: `Consultation started successfully`
          },
        });
      } catch (error){
        const error_message = get(error, "response.data.message") || error.message
        this.errorMessage = error_message;

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error_message
          },
        });
      } finally {
        this.loading = false;
      }
    },
    updateGraphByRegion(region){
      this.fetchDashboardGraphData(region)
    }
  }
}
</script>

<style lang="scss">
  @import '@core/scss/vue/pages/dashboard-ecommerce.scss';
  @import '@core/scss/vue/libs/chart-apex.scss';

  .circle {
    width: 10px;
    height: 10px;
    margin-top: 4px;
    border-radius: 50%;
    background-color: #ddd;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    font-weight: bold;
    color: #fff;
    position: relative;
    z-index: 1;
  }

  .first-schedule{
    width: 90%; 
    border: 0.8px solid rgba(0, 0, 0, 0.2); 
    border-radius: 14px; 
    margin-right: 2em; 
    padding: 1em; 
    margin-bottom: 1em;

    @media screen and (max-width: 992px) {
      margin-left: 1em;
    }
  }

  .highlight{
    font-weight: 400; 
    font-size: 13px; 
    line-height: 19.5px; 
    color: #077DBC
  }

  .schedule-info{
    font-weight: 400; 
    font-size: 13px; 
    line-height: 19.5px;
  }
  .schedules{
    width: 90%; 
    margin-right: 2em; 
    margin-bottom: 1em; 
    font-weight: 400; 
    font-size: 13px; 
    line-height: 19.5px; 

    @media screen and (max-width: 992px) {
      margin-left: 1em;
    }
  }

  .begin-session{
    font-weight: 400; 
    font-size: 11px; 
    line-height: 16.5px; 
  }
</style>
